
export class FileSummary {

    label: string;
    value: string;
    color: string;

    constructor() {
        this.label = "";
        this.value = "";
        this.color = "";
    }

}